import { Component } from '@angular/core';

@Component({
  selector: 'app-x-placeholder-row',
  standalone: true,
  imports: [],
  templateUrl: './x-placeholder-row.component.html',
  styleUrl: './x-placeholder-row.component.less'
})
export class XPlaceholderRowComponent {

}
